import { render, staticRenderFns } from "./VehicleRootPage.vue?vue&type=template&id=18032803&"
import script from "./VehicleRootPage.vue?vue&type=script&lang=js&"
export * from "./VehicleRootPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports